import { useEffect, useState } from "react";
import { marks, type Mark } from "../state/market";

/** A market's mark sampled at most once every `ms`: what the slip quotes against, so a busy book
 * does not recount the odds on every tick. */
export function useSampledMark(instrumentId: number | undefined, ms = 1_000): Mark | undefined {
  const read = () => (instrumentId === undefined ? undefined : marks.get()[instrumentId]);
  const [mark, setMark] = useState(read);
  useEffect(() => {
    setMark(read());
    const timer = setInterval(() => setMark(read()), ms);
    // the first mark arrives between samples: take it at once
    const stop = marks.subscribe(() => setMark((held) => held ?? read()));
    return () => {
      clearInterval(timer);
      stop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instrumentId, ms]);
  return mark;
}

/** The time now, ticking every `ms`. */
export function useNow(ms = 1_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), ms);
    return () => clearInterval(timer);
  }, [ms]);
  return now;
}

/** A short buzz on phones that allow it. */
export function buzz(ms = 12) {
  try {
    navigator.vibrate?.(ms);
  } catch {
    // not allowed here
  }
}
